import { gql } from '@apollo/client';

export const GET_CUSTOM_AD_OVERLAYS = gql`
  query CustomOverlays {
    customOverlays
      @rest(type: "AdOverlays", path: "/v4/ad-overlays", method: "GET") {
      id
      customer_id
      svg
      placement
      template_code
      content_fields
      # SYM-6301. Which Logo row the design shows, and which button to light on an untouched ad.
      # Same trap as \`available\` below: without asking here both arrive undefined, and the editor
      # falls back to no row at all -- which is exactly what QA showed on the first hand run.
      logo_choice
      logo_place_default
    }
  }
`;

export const GET_DEFAULT_AD_OVERLAYS = gql`
  query DefaultOverlays {
    defaultOverlays
      @rest(
        type: "DefaultOverlays"
        path: "/v4/default-ad-overlays"
        method: "GET"
      ) {
      id
      svg
      placement
      template_code
      content_fields
      # SYM-6060. ⚠️ A FIELD THE SERVER SENDS IS NOT A FIELD THE APP RECEIVES. The REST link trims
      # every response to the fields named here, so a field left out of this list arrives as
      # undefined however correctly the API sends it. That is not a hypothetical: the availability
      # field was added to the API, to the type and to the picker, and every design still rendered
      # as unlocked on QA because this line was missing.
      available
      # SYM-6301. See the note on GET_CUSTOM_AD_OVERLAYS: the Logo row is declared by the design.
      logo_choice
      logo_place_default
    }
  }
`;
